/* eslint-disable */
import React, { useImperativeHandle, forwardRef, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ImLocation } from 'react-icons/im';
import classes from './locationFiltersOverlay.module.css';
import {
  useGetAllNeighborhoodsQuery,
  useGetAllProvincesQuery,
  useGetAllTownsQuery
} from '../../store/apiSlice/apiSlice';
import { useSelector } from 'react-redux';
import DropDown from '../DropDown/DropDown';
import { Radio } from '../Radio/Radio';
import Button from '../Button/Button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { allowLocation } from '../../Helper/allowLocation';

const LocationFiltersOverlay = forwardRef((props, ref) => {
  const { setLocationState, setClose, locationState, setSearchText } = props;
  const { t } = useTranslation('webCommon');
  const [filters, setFilters] = useState({
    province: locationState?.province,
    town: locationState?.town,
    neighborhood: locationState?.neighborhood,
    nearby: locationState?.nearby,
    latitude: locationState?.latitude,
    longitude: locationState?.longitude
  });
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { data: provinces, isLoading: isGettingProvinces } = useGetAllProvincesQuery();
  const { data: towns, isLoading: isGettingTowns } = useGetAllTownsQuery(
    {
      ref: locationState.province?._id
    },
    { skip: !locationState.province?._id }
  );
  const { data: neighborhoods, isLoading: isGettingNeighborhoods } = useGetAllNeighborhoodsQuery(
    {
      ref: locationState.town?._id
    },
    { skip: !locationState.town?._id }
  );

  const updateValue = (key, val) => {
    setLocationState((prev) => ({
      ...prev,
      [key]: val
    }));
  };
  const applyFilters = async () => {
    let loc = {};
    if (filters?.nearby) {
      loc = await allowLocation();
    }
    const body = {
      province: filters?.province,
      town: filters?.town,
      neighborhood: filters?.neighborhood,
      nearby: filters?.nearby,
      ...(filters?.nearby && {
        lat: loc?.latitude,
        lng: loc?.longitude
      })
    };
    setLocationState((prev) => ({
      ...prev,
      ...body
    }));
    setClose && setClose('');
    let clearSearch = false;
    for (let key in body) {
      if (body[key]) {
        clearSearch = true;
      }
    }
    setSearchText && clearSearch && setSearchText('');
  };
  const clearFilters = () => {
    setLocationState((prev) => ({
      ...prev,
      province: null,
      town: null,
      neighborhood: null,
      nearby: false,
      longitude: null,
      latitude: null
    }));
    setClose && setClose('');
  };
  // useImperativeHandle(
  //   ref,
  //   () => {
  //     return {
  //       updateLocation(params) {
  //         setFilters({
  //           province: params?.province,
  //           town: params?.town,
  //           neighborhood: params?.neighborhood,
  //           nearby: params?.nearby,
  //           longitude: params?.lng,
  //           latitude: params?.lat
  //         });
  //       }
  //     };
  //   },
  //   []
  // );
  return (
    <div>
      <Row className={classes.row}>
        <Col md={12} className={classes.headWithIcon}>
          <ImLocation /> <h6>{t('locationFilters.location')}</h6>
        </Col>
        <Col md={12}>
          <DropDown
            placeholder={t('locationFilters.province')}
            value={locationState?.province}
            setValue={(e) => {
              setLocationState((prev) => ({
                ...prev,
                lat: null,
                lng: null,
                nearby: false,
                province: e
              }));
            }}
            options={provinces?.data}
            optionValue={'_id'}
            getOptionLabel={(e) => e?.name?.[selectedLanguage]}
            disabled={isGettingProvinces || locationState?.lng || locationState?.lat}
          />
        </Col>
        <Col md={12}>
          <DropDown
            placeholder={t('locationFilters.town')}
            value={locationState?.town}
            setValue={(e) => {
              setLocationState((prev) => ({
                ...prev,
                lat: null,
                lng: null,
                nearby: false,
                town: e
              }));
            }}
            options={towns?.data}
            optionValue={'_id'}
            getOptionLabel={(e) => e?.name?.[selectedLanguage]}
            disabled={isGettingTowns || locationState?.lng || locationState?.lat}
          />
        </Col>
        <Col md={12}>
          <DropDown
            placeholder={t('locationFilters.neighborhood')}
            value={locationState?.neighborhood}
            setValue={(e) => {
              setLocationState((prev) => ({
                ...prev,
                lat: null,
                lng: null,
                nearby: false,
                neighborhood: e
              }));
            }}
            options={neighborhoods?.data}
            optionValue={'_id'}
            getOptionLabel={(e) => e?.name?.[selectedLanguage]}
            disabled={isGettingNeighborhoods || locationState?.lng || locationState?.lat}
          />
        </Col>
        <Col md={12}>
          {/* <Radio
            label={t('locationFilters.nearby')}
            value={locationState?.nearby ? t('locationFilters.nearby') : ''}
            setValue={async (e) => {
              const loc = await allowLocation();
              if (!loc) return;
              if (!e) {
                setLocationState((prev) => ({
                  ...prev,
                  lat: null,
                  lng: null,
                  nearby: false
                }));
              } else {
                setLocationState((prev) => ({
                  ...prev,
                  province: null,
                  town: null,
                  neighborhood: null,
                  lat: loc?.latitude,
                  lng: loc?.longitude,
                  nearby: true
                }));
              }
            }}
          /> */}
          <div
            onClick={() => {
              if (locationState?.nearby) {
                setLocationState((prev) => ({
                  ...prev,
                  lat: null,
                  lng: null,
                  nearby: false
                }));
              }
            }}>
            <Radio
              variant={''}
              label={t('locationFilters.nearby')}
              value={locationState?.nearby ? t('locationFilters.nearby') : ''}
              setValue={async (e) => {
                if (!e) return;
                const loc = await allowLocation();
                if (!loc) return;
                setLocationState((prev) => ({
                  ...prev,
                  province: null,
                  town: null,
                  neighborhood: null,
                  lat: loc.latitude,
                  lng: loc.longitude,
                  nearby: true
                }));
              }}
            />
          </div>
        </Col>
        <Col md={12}>
          {/* <div className={classes.spBtw}> */}
          <Button borderRadius={'8px'} className={classes.clearBtn} onClick={() => clearFilters()}>
            {t('locationFilters.clearBtn')}
          </Button>
          {/* <Button
              borderRadius={'3px'}
              className={classes.btnMaxContent}
              onClick={() => {
                setClose && setClose('');
              }}
              // onClick={() => applyFilters()}
            >
              {t('locationFilters.applyBtn')}
            </Button> */}
          {/* </div> */}
        </Col>
      </Row>
    </div>
  );
});

export default LocationFiltersOverlay;
